import React, { FC, ReactNode } from 'react';
import { Textarea as MTextarea } from '@mantine/core';
import classNames from 'classnames';

import styles from './styles.module.scss';

interface Props {
  label: string;
  placeholder: string;
  className?: string;
  autoSize: boolean;
  minRows?: number;
  maxRows?: number;
  error?: ReactNode;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
}

const Textarea: FC<Props> = ({
  label,
  placeholder,
  autoSize = false,
  minRows,
  maxRows,
  onChange,
  className,
  error,
}: Props): JSX.Element => {
  return (
    <MTextarea
      className={classNames(styles['textarea'], className)}
      placeholder={placeholder}
      label={label}
      error={error}
      autosize={autoSize}
      minRows={minRows}
      maxRows={maxRows}
      onChange={(e) => onChange(e)}
    />
  );
};

export default Textarea;
